// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"119":"4a4f0903","308":"b17c121d","788":"eee9d3b1","938":"df7a1edc"}[chunkId] + ".chunk.js";
};